import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { t } from '@/plugins/i18n';
import { useLocationsStore, useNewFloorStore } from '@/stores'
import { BasicLocation } from '@eencloud/eewc-components/src/service/api-types'
import TooltippedText
  from "@eencloud/eewc-components/src/components/tooltip/TooltippedText/TooltippedText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectLocation',
  props: {
    stepIndex: null
  },
  setup(__props: any) {

const props = __props as {
  stepIndex: number
};



const locations = useLocationsStore()
const newFloorStore = useNewFloorStore()

// Select button
const currentLocation = computed(() => {
  return {
    text: newFloorStore?.selectedLocation?.name,
    value: newFloorStore?.selectedLocation?.id,
    ...newFloorStore?.selectedLocation
  }
})

const selectLocation = async function(location: BasicLocation) {
  newFloorStore.$patch({ selectedLocation: location })
  newFloorStore.setIsCompletedStep(props.stepIndex, true)
  await newFloorStore.getAllFloorsByLocationId()
}

return { __sfc: true,props, locations, newFloorStore, currentLocation, selectLocation, t, TooltippedText }
}

})